export const brandedButtonStyles = (theme) => ({
  'root': {
    borderRadius: '.6rem',
    fontSize: '.75rem',
    padding: '.75rem',
    fontWeight: 'bold',
    textTransform: 'none',
  },
  'label': {
    justifyContent: 'start',
    // display: 'block',
    width: '100%',
  },
  'disabled': {
    fontWeight: 'normal !important',
    color: `${theme.palette.common.swatch[600]} !important`,
    backgroundColor: `${theme.palette.common.swatch[200]} !important`,
    border: `1px solid ${theme.palette.common.swatch[200]} !important`,
  },
  'containedPrimary': {
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.dark,
    },
    // Secondary blue styling
    '&.alt': {
      'backgroundColor': `${theme.palette.common.swatch[300]}`,
      'fontWeight': 'normal',
      'color': theme.palette.common.black,
      '&:hover': {
        backgroundColor: theme.palette.primary.altLight,
        color: theme.palette.primary.main,
      },
      '&:focus': {
        backgroundColor: theme.palette.primary.altDark,
        color: theme.palette.primary.main,
      },
    },
  },
  'startIcon': {},
  'iconSizeLarge': {},
  'outlinedPrimary': {
    'fontWeight': 'normal',
    'backgroundColor': theme.palette.common.white,
    'color': theme.palette.common.black,
    'border': `1px solid ${theme.palette.common.swatch[500]}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.altLight,
      border: `1px solid ${theme.palette.primary.altLight}`,
      color: theme.palette.primary.main,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.altDark,
      border: `1px solid ${theme.palette.primary.altDark}`,
      color: theme.palette.primary.swatch[800],
    },
  },
  'outlinedSecondary': {
    'fontWeight': 'normal',
    'backgroundColor': theme.palette.common.white,
    'color': theme.palette.common.black,
    'border': `1px solid ${theme.palette.common.swatch[500]}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary.altLight,
      border: `1px solid ${theme.palette.secondary.altLight}`,
    },
    '&:focus': {
      backgroundColor: theme.palette.secondary.altDark,
      border: `1px solid ${theme.palette.secondary.altDark}`,
    },
  },
  'sizeSmall': {
    borderRadius: '.4rem',
    height: '1.5rem',
    fontSize: '.8rem',
  },
  'sizeLarge': {
    borderRadius: '.75rem',
    height: '3rem',
    fontSize: '1.05rem',
    paddingLeft: '1.125rem',
    paddingRight: '1.125rem',
  },
  'outlinedSizeLarge': {
    fontSize: '.875rem',
  },
});

export default brandedButtonStyles;
